import(/* webpackMode: "eager" */ "/app/src/app/[locale]/studies/page.tsx");
